import { render, staticRenderFns } from "./Latest.vue?vue&type=template&id=e7146714&scoped=true&"
import script from "./Latest.vue?vue&type=script&lang=js&"
export * from "./Latest.vue?vue&type=script&lang=js&"
import style0 from "./Latest.vue?vue&type=style&index=0&id=e7146714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7146714",
  null
  
)

export default component.exports